import axios from 'axios';
import { ResetPasswordTypes } from 'pages/Auth/auth.types';

export const signUpAsync = async ({
  firstName,
  lastName,
  username,
  email,
  country,
  countryCode,
  password,
}: {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  country: string;
  countryCode: string;
  password: string | undefined;
}) => {
  return await axios.post(`/users`, {
    firstName,
    lastName,
    username,
    email,
    country,
    countryCode,
    password,
  });
};

export const signInAsync = async ({
  // username,
  email,
  password,
}: {
  // username: string;
  email: string;
  password: string | undefined;
}) => {
  return await axios.post(`/authorization/login`, {
    // username,
    email,
    password,
  });
};

export const signInGoogleAsync = async ({
  googleIdToken,
}: {
  googleIdToken: string;
}) => {
  return await axios.post(`/authorization/signup/google`, {
    googleIdToken,
  });
};

export const signInGoogleCompleteAsync = async ({
  firstName,
  lastName,
  username,
  country,
  countryCode,
}: {
  firstName: string;
  lastName: string;
  username: string;
  country: string;
  countryCode: string;
}) => {
  return await axios.patch(`/users/google/complete-profile`, {
    firstName,
    lastName,
    username,
    country,
    countryCode,
  });
};

export const updateUserProfileAsync = async ({
  formData,
}: {
  formData: FormData;
}) => {
  return await axios.put(`/users`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getUserAsync = async () => {
  const { data } = await axios.get(`/users`);
  return data;
};

export const sendResetPasswordEmailAsync = async ({
  type,
  userId,
}: {
  type: number;
  userId: string | number;
}) => {
  console.log(userId);
  console.log(type);
  return await axios.post(
    `/authorization/forgotten-password/email`,
    type === ResetPasswordTypes.EMAIL
      ? {
          email: userId,
        }
      : type === ResetPasswordTypes.ID
      ? {
          userId: Number(userId),
        }
      : {
          username: userId,
        }
  );
};
